'use strict';

import raven from 'raven';

import FormController from 'app/controllers/form';

import StatesTemplatesDialogController from './states-templates.dialog.controller';
import StatesTemplatesDialogTpl from './states-templates.dialog.html';

import ChooseStatesTemplateDialogController from './choose-states-template.dialog.controller';
import ChooseStatesTemplateDialogTpl from './choose-states-template.dialog.html';

import NewVehicleController from '../quote/new-vehicle.controller';
import NewVehicleTpl from '../quote/new-vehicle.html';
import { getVehicleLabel } from 'app/directives/vehicle';

// eslint-disable no-unused-vars
import OperationsService from 'services/operations.service';
import OperationProceduresService from 'services/operation-procedures.service';
import OPHistoriesService from 'services/operation-procedure-histories.service';
import VehiclesService from 'services/vehicles.service';
import AgenciesService from 'services/agencies.service';
import CreditorsService from 'services/creditors.service';
import OCommentsService from 'services/operation-comments.service';
import LoginService from 'services/login.service';
import CronologiesService from 'services/cronologies.service';
// eslint-enable

import ngAsync from 'app/async/async.function.decorator';

export default class OperationController extends FormController {
  OperationsService: OperationsService;
  OperationProceduresService: OperationProceduresService;
  OPHistoriesService: OPHistoriesService;
  VehiclesService: VehiclesService;
  AgenciesService: AgenciesService;
  CreditorsService: CreditorsService;
  OCommentsService: OCommentsService;
  LoginService: LoginService;
  CronologiesService: CronologiesService;
  $scope: any;
  $state: any;
  $mdToast: any;
  $mdDialog: any;
  $location: any;

  model: any;
  operationProcedures: any[];
  operationType: any;
  form: any;
  showSpin: boolean;
  showNewVehicleSpin: boolean;
  editable: boolean;
  editing: boolean;
  statesTemplates: any[];
  client: any;
  potentialClients: any[];
  holder: any;
  potentialHolders: any[];
  vehicle: any;
  searchVehicleText: string;
  agency: any;
  searchAgencyText: string;
  creditor: any;
  searchCreditorText: string;
  operationComments: any[];
  status: boolean;
  approvalDate: any;
  selectedTabIndex: number;
  openOperationProcedureId: number;

  owner: any;
  owners: any[] = [];

  agenciesDraft: any[];
  typesOperationDraft: any[];

  enableDraft: boolean;

  cronologies: any[] = [];

  static $inject = [
    'OperationsService',
    'OperationProceduresService',
    'OPHistoriesService',
    'VehiclesService',
    'AgenciesService',
    'CreditorsService',
    'OCommentsService',
    'LoginService',
    'CronologiesService',
    '$scope',
    '$state',
    '$mdToast',
    '$mdDialog',
    '$location',
    '$stateParams'
  ];
  constructor(
    OperationsService,
    OperationProceduresService,
    OPHistoriesService,
    VehiclesService,
    AgenciesService,
    CreditorsService,
    OCommentsService,
    LoginService,
    CronologiesService,
    $scope,
    $state,
    $mdToast,
    $mdDialog,
    $location,
    $stateParams
  ) {
    super(
      $scope.$parent.$resolve.operation,
      'Operacion',
      OperationsService,
      null,
      'operations'
    );

    const operation = $scope.$parent.$resolve.operation;

    Object.assign(this, {
      OperationsService,
      OperationProceduresService,
      OPHistoriesService,
      VehiclesService,
      AgenciesService,
      CreditorsService,
      OCommentsService,
      LoginService,
      CronologiesService,
      operationTypes: $scope.$parent.$resolve.operationTypes,
      statesTemplates: $scope.$parent.$resolve.statesTemplates,
      $scope,
      $state,
      $mdToast,
      $mdDialog,
      $location
    });

    const {
      openOperationProcedureId,
      openProcedures
    }: {
      openOperationProcedureId: number;
      openProcedures: boolean;
    } = $stateParams;
    if (openOperationProcedureId || openProcedures) {
      this.selectedTabIndex = 1; // tramites
      /* Open the passed procedure id or the only existent one */
      this.openOperationProcedureId =
        openOperationProcedureId ||
        (this.model.operationProcedures.length === 1 &&
          this.model.operationProcedures[0].id);
    }

    //List of agencies authorized to draf operation
    this.agenciesDraft = [1];
    //List of types operations authorized to draf operation
    this.typesOperationDraft = [2];

    this.owner = {
      name: '',
      surname: '',
      percentage: null
    };

    if (this.model.id) {
      Object.assign(this, {
        operationType: this.model.operationType,
        operationProcedures: this.model.operationProcedures,
        operationComments: this.model.operationComments,
        client: this.model.client,
        holder: this.model.holder,
        vehicle: this.model.vehicle,
        agency: this.model.agency,
        creditor: this.model.creditor,
        owners: this.model.owners,
        approvalDate: this.model.approvalDate
      });
      this.loadCronologies();
    }
    this.potentialClients = this.client ? [this.client] : [];
    this.potentialHolders = this.holder ? [this.holder] : [];

    this.status = false;
    this.enableDraft = this.isEnableToDraft();
  }

  $onInit() {
    super.$onInit();
    this.model.status;
    //console.log(this.model); //.operationProcedures.operationsProcedureHistories[0].createdByUser.email);
  }

  @ngAsync()
  async loadCronologies() {
    this.cronologies = await this.CronologiesService.find({
      filter: {
        where: {
          operationId: this.model.id
        },
        order: 'createdAt DESC',
        include: ['createdByUser']
      }
    });
  }

  saveDraft(ev) {
    if (!this.form.$valid) {
      return;
    }

    var confirm = this.$mdDialog
      .confirm()
      .title('Atencion')
      .textContent('¿Desea guardar la operacion como Borrador?')
      .ariaLabel('...')
      .targetEvent(ev)
      .ok('Si')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(result => {
      this.model.status = 'draft';
      this.model.approvalDate = null;
      this.OperationsService.save(this.model).then(() => {
        this.$location.url('/operations');
      });
    });
  }

  isEnableToDraft() {
    let agency = !!this.agenciesDraft.find(x => x === this.model.agencyId);
    let type = !!this.typesOperationDraft.find(
      x => x === this.model.operationTypeId
    );
    return agency && type; //&& (this.model.status!='approved');
  }

  void(ev) {
    var confirm = this.$mdDialog
      .confirm()
      .title('Atencion')
      .textContent('¿Desea archivar la operacion?')
      .ariaLabel('...')
      .targetEvent(ev)
      .ok('Si')
      .cancel('Cancelar');

    this.$mdDialog.show(confirm).then(result => {
      this.model.deletedAt = new Date();
      this.OperationsService.save(this.model).then(() => {
        this.$location.url('/operations');
      });
    });
  }

  addOwner() {
    let total = 0;
    let copy = Object.assign({}, this.owner);
    let alert;

    if (!this.owners || !this.owners.length) {
      this.owners = [];
    }

    this.owners.forEach(item => {
      total = total + item.percentage;
    });

    if (total + this.owner.percentage <= 100) {
      this.owners.push(copy);
    } else {
      alert = this.$mdDialog
        .alert()
        .title('No es posible')
        .textContent('La suma de porcentajes de los titulares supera el 100 %')
        .ok('Ok');

      this.$mdDialog.show(alert);
    }
  }

  removeOwner(owner) {
    this.owners.splice(this.owners.indexOf(owner), 1);
  }

  onNewOP($event) {
    const operationProcedures = $event.operationProcedures;
    const newOPs = operationProcedures.filter(
      op => !this.operationProcedures.some(o => o.id == op.id)
    );

    if (newOPs) {
      this.operationProcedures.push(...newOPs);
    }
  }

  onOperationTypeChange() {
    this.model.operationTypeId = this.operationType.id;
    this.enableDraft = this.isEnableToDraft();
  }

  save() {
    if (!this.form.$valid) {
      return;
    }

    this.model.approvalDate = new Date();
    this.model.status = 'approved';

    let ownersTmp = JSON.stringify(this.owners);

    let firstTimeSave = false;
    this.showSpin = true;

    const onSave = operation => {
      Object.assign(this.model, operation);

      this.showSpin = false;
      this.editable = true;
      this.editing = false;

      if (firstTimeSave) {
        this.updateLocation();
      }
    };

    if (!this.model.id) {
      firstTimeSave = true;
      this.$mdDialog
        .show({
          controller: StatesTemplatesDialogController,
          template: StatesTemplatesDialogTpl,
          clickOutsideToClose: true,
          fullscreen: true,
          locals: {
            statesTemplates: this.operationType.statesTemplates
          }
        })
        .then(
          selectedStatesTemplates => {
            const statesTemplates = Object.keys(selectedStatesTemplates).filter(
              s => selectedStatesTemplates[s]
            );
            this.OperationsService.createNew({
              operationData: this.model,
              statesTemplates
            })
              .then(res => res.operation)
              .then(onSave);
          },
          () => {
            this.showSpin = false;
            this.editable = false;
            this.editing = true;
          }
        );
    } else {
      //console.log(this.model);
      this.model.owners = ownersTmp;
      this.OperationsService.save(this.model).then(onSave);
    }
  }

  async addProcedure() {
    const statesTemplate = await this.$mdDialog.show({
      controller: ChooseStatesTemplateDialogController,
      template: ChooseStatesTemplateDialogTpl,
      clickOutsideToClose: true,
      fullscreen: true,
      locals: {
        statesTemplates: this.statesTemplates
      }
    });
    try {
      const res = await this.OperationsService.addProcedure({
        operationId: this.model.id,
        statesTemplateId: statesTemplate.id
      });
      const operationProcedure = await this.OperationProceduresService.findOne({
        filter: {
          where: {
            id: res.operationProcedure.id
          },
          include: [
            {
              relation: 'operationProcedureHistories',
              scope: {
                include: ['createdByUser', 'updatedByUser'],
                order: 'createdAt ASC'
              }
            },
            'tasks',
            'currentTask'
          ]
        }
      });
      this.operationProcedures.push(operationProcedure);
      this.simpleSuccess();
    } catch (e) {
      raven.captureException(e);
      this.simpleError();
    }
  }

  removeProcedure(op) {
    const confirm = this.$mdDialog
      .confirm()
      .title('Confirmar eliminación de trámite')
      .textContent(
        `Esta operación eliminará el trámite y todas las tareas asociadas. \
Está seguro/a?`
      )
      .ok('Si, eliminar')
      .cancel('Cancelar');
    this.$mdDialog.show(confirm).then(() => {
      return this.OperationsService.removeProcedure({
        operationId: this.model.id,
        operationProcedureId: op.id
      }).then(
        () => {
          const index = this.operationProcedures.findIndex(o => o.id == op.id);
          this.operationProcedures.slice(index, 1);
          this.simpleSuccess();
        },
        err => {
          raven.captureException(err);
          this.simpleError();
        }
      );
    });
  }

  selectedClientChange() {
    this.model.clientId = this.client.id;
    this.model.client = this.client;
  }

  async onClientFilterUpdate($event) {
    this.potentialClients = await $event.clientsPromise;
  }

  selectedHolderChange() {
    this.model.holderId = this.holder.id;
    this.model.holder = this.holder;

    if (!this.client) {
      this.client = this.holder;
      this.model.clientId = this.holder.id;
      this.potentialClients = [this.client];
    }
  }

  async onHolderFilterUpdate($event) {
    this.potentialHolders = await $event.clientsPromise;

    if (!this.potentialHolders) {
      return;
    }

    // TODO: WTF? Why?
    const sameClientsHolders = this.potentialHolders.filter(h =>
      this.potentialClients.some(c => c.id == h.id)
    );
    const doReplace =
      !this.potentialClients.length ||
      sameClientsHolders.length == this.potentialHolders.length;
    if (doReplace) {
      this.potentialClients = this.potentialHolders;
    }
  }

  queryVehicleSearch() {
    return this.VehiclesService.getModels({
      where: {
        broad: this.searchVehicleText
      },
      order: 'plate DESC, number DESC, description DESC'
    }).then(vehicles => {
      return vehicles.map(v => {
        v.fullDesc = `${v.plate} - ${v.number} - ${v.description}`;
        return v;
      });
    });
  }

  selectedVehicleChange(vehicle) {
    if (!vehicle) {
      return;
    }

    this.vehicle = vehicle;
    this.model.vehicleId = vehicle.id;

    // Allow angular to update form validity status
    setTimeout(() => {
      if (!this.model.id && this.form.$valid) {
        this.OperationsService.find({
          filter: {
            where: {
              holderId: this.holder.id,
              vehicleId: this.vehicle.id
            },
            order: 'id DESC'
          }
        }).then(existingOperations => {
          let operat = existingOperations.length ? existingOperations[0] : null;
          return Promise.resolve()
            .then(() => {
              if (operat) {
                let confirm = this.$mdDialog
                  .confirm()
                  .title('Desea crear la operacion de todas maneras?')
                  .textContent(
                    `Atención: Ya existe una Operacion \
para mismo titular y dominio, desea crear la operacion igual?`
                  )
                  .ok(`Sí, crearlo de todas maneras`)
                  .cancel('Cancelar e ir a la operacion ya existente');

                return this.$mdDialog.show(confirm);
              }
            })
            .then(
              () => {
                this.save();
                this.editable = false;
                this.editing = true;
              },
              () => {
                this.$state.go('editOperation', {
                  id: operat.id
                });
              }
            );
        });
      } else {
        //console.debug(this.form);
      }
    }, 0);
  }

  getVehicleLabel(vehicle) {
    return getVehicleLabel(vehicle);
  }

  newVehicle(ev, initialPlate) {
    this.searchVehicleText = '';
    this.$mdDialog
      .show({
        controller: NewVehicleController,
        template: NewVehicleTpl,
        targetEvent: ev,
        clickOutsideToClose: true,
        fullscreen: this.$scope.customFullscreen,
        locals: {
          initialPlate: initialPlate,
          VehiclesService: this.VehiclesService
        }
      })
      .then(data => {
        this.showNewVehicleSpin = true;
        let newVehicle = this.VehiclesService.create(data.vehicle);
        return this.VehiclesService.save(newVehicle);
      })
      .then(vehicle => {
        this.simpleSuccess(`El nuevo vehiculo ha sido creado
 correctamente`);
        this.showNewVehicleSpin = false;
        this.selectedVehicleChange(vehicle);
      });
  }

  queryAgencySearch() {
    return this.AgenciesService.getModels({
      where: {
        name: {
          ilike: `%${this.searchAgencyText}%`
        }
      }
    });
  }

  selectedAgencyChange(agency) {
    if (!agency) {
      return;
    }

    this.agency = agency;
    this.model.agencyId = agency.id;

    this.enableDraft = this.isEnableToDraft();
  }

  queryCreditorSearch() {
    return this.CreditorsService.getModels({
      where: {
        name: {
          ilike: `%${this.searchCreditorText}%`
        }
      }
    });
  }

  selectedCreditorChange(creditor) {
    if (!creditor) {
      return;
    }

    this.creditor = creditor;
    this.model.creditorId = creditor.id;
  }

  async addComment() {
    const confirm = this.$mdDialog
      .prompt()
      .title('Carga de comentario')
      .textContent('Ingrese comentarios')
      .placeholder('Comentarios')
      .ariaLabel('Comentarios')
      .required(true)
      .ok('Aceptar')
      .cancel('Cancelar');

    const response = await this.$mdDialog.show(confirm);
    let opComment = this.OCommentsService.create({
      comment: response,
      operationId: this.model.id
    });
    opComment = await this.OCommentsService.save(opComment);
    const user = await this.LoginService.getCachedCurrent();
    opComment.createdByUser = user;
    /* I think that babel translation prevents angular from detecting this
     change, therefore a manual $apply is required */
    this.$scope.$apply(() => {
      this.operationComments.unshift(opComment);
    });
  }
}
